class SliderControls{
    static updateCount(el, count, visible, index){

        const showing = el.querySelector("[data-visible]");
        const total = el.querySelector("[data-total]");

        showing.innerHTML = visible > 1 ? `${index} - ${index + (visible-1)}` : index;
        total.innerHTML = ` of ${count}`;
    }
}